import type { UIStrings } from './en';

export const de: UIStrings = {
  'site.title': 'DopeJs — Open-Source-Werkzeuge für die Entwicklung mit Agenten',
  'site.description':
    'DopeJs entwickelt Open-Source-Werkzeuge für KI-native Entwicklung: Agent-Runtimes, Coding-Agents fürs Terminal, CLI-Umgebungswerkzeuge und Canvas-Rendering-Engines.',

  'nav.projects': 'Projekte',
  'nav.about': 'Über uns',
  'nav.github': 'GitHub',
  'nav.skip': 'Zum Inhalt springen',
  'nav.theme': 'Design',
  'nav.language': 'Sprache',

  'hero.eyebrow': 'Open Source · offen entwickelt',
  'hero.title': 'Werkzeuge für KI-native Entwicklung.',
  'hero.body':
    'DopeJs ist eine kleine Gruppe von Open-Source-Projekten rund um eine Frage: Wie sieht die Software aus, die du täglich nutzt, wenn Agenten Teil des Ablaufs sind? Agent-Runtimes, Coding-Agents fürs Terminal, CLI-Umgebungswerkzeuge, Canvas-Rendering-Engines — alles öffentlich entwickelt.',
  'hero.cta.projects': 'Projekte ansehen',
  'hero.cta.github': 'Auf GitHub ansehen',
  'hero.count': 'Projekte',

  'projects.title': 'Projekte',
  'projects.repo': 'Repository',
  'projects.homepage': 'Website',
  'projects.install': 'Installieren',
  'projects.copy': 'Kopieren',
  'projects.copied': 'Kopiert',
  'projects.details': 'Details',

  'status.stable': 'Veröffentlicht',
  'status.active': 'Aktive Entwicklung',
  'status.early': 'Früh — nicht produktionsreif',
  'status.design': 'Entwurfsphase',

  'project.back': 'Alle Projekte',
  'project.overview': 'Überblick',
  'project.highlights': 'Was es leistet',
  'project.getStarted': 'Loslegen',
  'project.requirements': 'Voraussetzungen',
  'project.facts': 'Auf einen Blick',
  'project.facts.status': 'Status',
  'project.facts.languages': 'Sprachen',
  'project.facts.license': 'Lizenz',
  'project.facts.noLicense': 'Noch keine',
  'project.links': 'Links',
  'project.issues': 'Issues',
  'project.releases': 'Releases',
  'project.prev': 'Zurück',
  'project.next': 'Weiter',

  'about.title': 'Über DopeJs',
  'about.body':
    'Alles hier wird offen auf GitHub entwickelt. Issues und Pull Requests sind in jedem Repository willkommen — ebenso ehrliche Hinweise darauf, dass etwas noch nicht funktioniert. Mehrere dieser Projekte sind bewusst noch nicht veröffentlicht; wo das zutrifft, sagt es das Projekt selbst.',
  'about.cta': 'Der Organisation auf GitHub folgen',

  'footer.built': 'Gebaut mit React und Vite. Quellcode auf GitHub.',
  'footer.rights': 'DopeJs',
  'footer.translations': 'Übersetzungen sind maschinell erzeugt — Korrekturen sind willkommen.',
};
